export function addEntityIdToHash(id: string) {
  clearEntityIdFromHash()
  window.location.hash = `${window.location.hash}/#/edit/${id}`.replace(
    /\/+/g,
    '/'
  )
}

export function clearEntityIdFromHash() {
  const hash = window.location.hash
  window.location.hash = hash.replace(/\/#\/edit\/([^/]+)$/, '')
}

export function getEntityIdFromHash() {
  const hash = window.location.hash
  const pathMatch = hash.match(/\/#\/edit\/([^/]+)$/)
  if (!pathMatch) {
    return
  }
  return pathMatch[1]
}
